let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
class CategoryService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }

  getCategories(){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.category + (categoryId ? categoryId : '') + '&slug=' + (categorySlug ? categorySlug: ''),
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }

  getAttributesCategory(categoryId,categorySlug){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categoryAttributes + (categoryId ? categoryId : '') + '&slug=' + (categorySlug ? categorySlug : ''),
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }

  getCurrentCategory(categoryId, categorySlug){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.category + (categoryId ? categoryId : '') + '&slug=' + (categorySlug ? categorySlug : ''),
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }

  getSubcategories(categoryIdSlug, userId){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categoryArbol + (categoryIdSlug ? categoryIdSlug : '') + '&userId=' + userId,
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }
}

CategoryService.$inject = inject;

export default CategoryService;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category.service.js
 **/